import React from 'react';
import './Partners.css';
import akiLogo from '../assets/partners/aki.png';
import borLogo from '../assets/partners/bor.png';
import evsLogo from '../assets/partners/evs.png';
import guruLogo from '../assets/partners/guru.png';
import littleLogo from '../assets/partners/little.png';
import pepLogo from '../assets/partners/pep.png';
import prettyLogo from '../assets/partners/pretty.png';
import ranLogo from '../assets/partners/ran.png';
import stradaLogo from '../assets/partners/strada.png';

const Partners = () => {
  // Original partner logos
  const originalPartners = [
    { logo: akiLogo, alt: 'Aki' },
    { logo: borLogo, alt: 'Bor' },
    { logo: evsLogo, alt: 'EVS' },
    { logo: guruLogo, alt: 'Guru' },
    { logo: littleLogo, alt: 'Little' },
    { logo: pepLogo, alt: 'Pep' },
    { logo: prettyLogo, alt: 'Pretty' },
    { logo: ranLogo, alt: 'Ran' },
    { logo: stradaLogo, alt: 'Strada' },
  ];
  
  // Duplicate multiple times for seamless infinite loop
  // We need enough duplicates to ensure smooth infinite scrolling
  // Using 4 duplicates so the animation translates -25% (1/4) for seamless loop
  const partners = [
    ...originalPartners,
    ...originalPartners,
    ...originalPartners,
    ...originalPartners,
  ].map((partner, index) => ({
    ...partner,
    id: index + 1,
  }));

  return (
    <div className="partners-section">
      <div className="partners-label">
        <span className="partners-label-text">NOS PARTENAIRES</span>
      </div>
      <div className="partners-container">
        <div className="partners-scroll-wrapper">
          <div className="partners-fade-left"></div>
          <div className="partners-scroll">
            {partners.map((partner) => (
              <div key={partner.id} className="partner-logo-wrapper">
                <img 
                  src={partner.logo} 
                  alt={partner.alt}
                  className="partner-logo"
                  draggable="false"
                />
              </div>
            ))}
          </div>
          <div className="partners-fade-right"></div>
        </div>
      </div>
    </div>
  );
};

export default Partners;

